import React from 'react';
import { styled, SxProp } from 'dripsy';
import { View } from 'react-native';
import { observer } from 'mobx-react-lite';

import { Image } from '../../common/Image';
import { Touchable } from '../../common/Touchable';
import { Icon } from '../../common/Icon';
import { CoverView } from '../CoverView';
import { UploadMedia } from '@models/Posts/UploadMediaModel';
import { createAspectRatioStyles } from '@styles';
import { MediaUploadItemCover } from './MediaUploadItemCover';

const Container = styled(View)({
  flex: 1,
});

const ContainerCoverView = styled(CoverView)({
  ...createAspectRatioStyles(1, '100%'),
  borderRadius: 4,
  overflow: 'hidden',
});

const coverViewStyles: SxProp = {
  alignItems: 'center',
  justifyContent: 'center',
};

const MediaImage = styled(Image)({
  flex: 1,
  bg: '$background20',
});

const RemoveTouchableContainer = styled(Touchable)({
  position: 'absolute',
  top: 8,
  right: 8,
  size: 32,
  borderRadius: 12,
  overflow: 'hidden',
  alignItems: 'center',
  justifyContent: 'center',
});

const RemoveTouchableBackground = styled(View)({
  position: 'absolute',
  bg: '$background20',
  opacity: 0.4,
  zIndex: -1,
  size: '100%',
});

export interface IMediaUploadItemProps {
  item: UploadMedia;
  onRemove(item: UploadMedia): void;
}

export const MediaUploadItem = observer<IMediaUploadItemProps>(
  ({ item, onRemove }) => {
    return (
      <Container>
        <ContainerCoverView
          isVisible={item.isUploadingOrError}
          coverComponentSx={coverViewStyles}
          CoverComponent={() => <MediaUploadItemCover item={item} />}
        >
          <MediaImage source={{ uri: item.previewUri }} />
        </ContainerCoverView>

        <RemoveTouchableContainer onPress={() => onRemove(item)}>
          <RemoveTouchableBackground />
          <Icon name="close-light" size={26} />
        </RemoveTouchableContainer>
      </Container>
    );
  },
);
